import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { SnowplowContext } from '@/helpers/tracking/providers';

import TitleDetailInfoRow from '@/pages/titleDetailV1/components/titleDetailInfoRow.vue';
import { faVolumeMute, faVolumeUp, faSpinner } from '@fortawesome/free-solid-svg-icons';
import BackgroundVideoPlayer from '@/features/background-video-player/components/BackgroundVideoPlayer.vue';
import type BackgroundVideoPlayerType from '@/features/background-video-player/components/BackgroundVideoPlayer.vue';
import CinematicRentalCard from './CinematicRentalCard.vue';
import { getTVODBackdropClips } from '@/helpers/title-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TVODHeroSection',
  props: {
    title: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
};



const jwtvTvodOffer = computed(() => props.title.rent.find(offer => offer.package.shortName === 'jwt'));
const selectedClip = computed(() => {
	return getTVODBackdropClips(props.title)?.[0] ?? null;
});

// Title and Description
const titleName = computed(() => {
	return props.title.__typename === 'Season' ? props.title.show.content.title : props.title.content.title;
});

const description = computed(() => {
	return props.title.content.shortDescription || '';
});

// Backdrop image
const imageUrls = computed(() => props.title.content.backdrops.map(b => b.backdropUrl));

// Video ready state
const isVideoReady = ref(false);

function handleVideoReady() {
	isVideoReady.value = true;
}

// Mute Toggle
const isMuted = ref(true);
const backgroundPlayerRef = ref<InstanceType<typeof BackgroundVideoPlayerType> | null>(null);

function toggleMute() {
	if (isMuted.value) {
		backgroundPlayerRef.value?.unmute();
		isMuted.value = false;
	} else {
		backgroundPlayerRef.value?.mute();
		isMuted.value = true;
	}
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'toggle_mute',
			value: isMuted.value ? 1 : 0,
		},
		props.additionalContexts
	);
}

// Read More Functionality
const isDescriptionExpanded = ref(false);
const showReadMoreButton = ref(false);
const descriptionRef = ref<HTMLElement | null>(null);

onMounted(() => {
	// Check if description exceeds 3 lines
	if (descriptionRef.value) {
		const lineHeight = parseInt(getComputedStyle(descriptionRef.value).lineHeight);
		const maxHeight = lineHeight * 3;
		showReadMoreButton.value = descriptionRef.value.scrollHeight > maxHeight;
	}
});

function toggleDescription() {
	isDescriptionExpanded.value = !isDescriptionExpanded.value;
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: isDescriptionExpanded.value ? 'read_more_clicked' : 'read_less_clicked',
			label: 'synopsis',
		},
		props.additionalContexts
	);
}

return { __sfc: true,props, jwtvTvodOffer, selectedClip, titleName, description, imageUrls, isVideoReady, handleVideoReady, isMuted, backgroundPlayerRef, toggleMute, isDescriptionExpanded, showReadMoreButton, descriptionRef, toggleDescription, TitleDetailInfoRow, faVolumeMute, faVolumeUp, faSpinner, BackgroundVideoPlayer, CinematicRentalCard }
}

})